import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/axios";
import { MANAGER } from "../config/api";
import toast from "react-hot-toast";

function OrderPage() {
  const [order, setOrder] = useState(null);
  const [orderItems, setOrderItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const Navigate = useNavigate();

  const token = localStorage.getItem("token");

  // Fetch pending order
  const fetchOrder = async () => {
    try {
      const { data } = await apiClient.get(MANAGER.PENDING_ORDER);
      if (data.order) {
        setOrder(data.order);
        setOrderItems(data.items);
        const totalAmount = data.items.reduce(
          (sum, item) => sum + item.price * item.quantity,
          0
        );
        setTotal(totalAmount);
      } else {
        setOrder(null);
        setOrderItems([]);
        setTotal(0);
      }
    } catch (err) {
      console.error("Error fetching pending order:", err);
      toast.error(err.response?.data?.message || err.message || "Failed to fetch pending order");
    }
  };

  useEffect(() => {
    fetchOrder();
  }, []);

  // Update quantity locally
  const updateQty = (id, type) => {
    const updatedItems = orderItems
      .map((item) =>
        item._id === id
          ? { ...item, quantity: type === "inc" ? item.quantity + 1 : item.quantity - 1 }
          : item
      )
      .filter((item) => item.quantity > 0);

    setOrderItems(updatedItems);
    const newTotal = updatedItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    setTotal(newTotal);
  };

  // Remove item locally
  const removeItem = (id) => {
    const updatedItems = orderItems.filter((item) => item._id !== id);
    setOrderItems(updatedItems);
    const newTotal = updatedItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    setTotal(newTotal);
  };

  // Make payment
  const makePayment = async () => {
    if (!order) return;
    setLoading(true);

    try {
      const { data } = await apiClient.post(MANAGER.PAY_ORDER(order._id), {
        items: orderItems,
        total,
      });

      if (!data.success) throw new Error(data.message || "Payment failed");

      toast.success("Payment successful!");
      setOrder(null);
      setOrderItems([]);
      setTotal(0);
      Navigate('/dashboard');

    } catch (err) {
      console.error("Payment error:", err);
      toast.error(err.response?.data?.message || err.message || "Payment failed");
    } finally {
      setLoading(false);
    }
  };

  

  return (
    <div
  style={{
    backgroundColor: "#121212",
    color: "#e0e0e0",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: "50px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  }}
>
  <div
    style={{
      width: "700px",
      backgroundColor: "#1e1e2a",
      borderRadius: "12px",
      padding: "30px",
      boxShadow: "0 5px 20px rgba(0,0,0,0.5)",
    }}
  >
    <h2 style={{ textAlign: "center", marginBottom: "25px", color: "#fff" }}>
      Pending Payment
    </h2>

    <div style={{ marginBottom: "20px" }}>
      {orderItems.map((item) => (
        <div
          key={item._id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "8px 0",
            borderBottom: "1px solid #333",
            fontSize: "16px",
          }}
        >
          <span>{item.menu_item.name} x{item.quantity}</span>
          <span>Rs.{(item.price * item.quantity).toFixed(2)}</span>
        </div>
      ))}
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: "18px",
        fontWeight: "bold",
        marginBottom: "25px",
        paddingTop: "10px",
        borderTop: "1px solid #333",
      }}
    >
      <span>Total</span>
      <span>Rs.{total.toFixed(2)}</span>
    </div>

    <button
      onClick={makePayment}
      disabled={loading}
      style={{
        width: "100%",
        padding: "12px 0",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "#28a745",
        color: "#fff",
        fontSize: "18px",
        fontWeight: "bold",
        cursor: "pointer",
        transition: "all 0.2s",
      }}
      onMouseEnter={(e) => {
        e.target.style.backgroundColor = "#218838";
        e.target.style.transform = "scale(1.03)";
      }}
      onMouseLeave={(e) => {
        e.target.style.backgroundColor = "#28a745";
        e.target.style.transform = "scale(1)";
      }}
    >
      {loading ? "Processing..." : "Make Payment"}
    </button>
  </div>
</div>
  );
}

export default OrderPage;
